import { ButtonToolbar, Dropdown, DropdownButton } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react'
import { printData } from '../Action'
import { DesignContext } from 'contexts/DesignContext'
import { useContext } from 'react'
import objectPath from 'object-path'

const PrintButton = ({ showPrintButton, formData, rowSelection }) => {
  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext
  const componentPropsData = objectPath.get(jsonForm, 'componentPropsData')
  const designerData = objectPath.get(componentPropsData, 'data')
  const datasourceValue = objectPath.get(designContext, '@datasource') || {}

  return (
    <ButtonToolbar>
      <DropdownButton
        title={
          <>
            <FeatherIcon size="14" icon="printer" className="mr-1" />
            {showPrintButton?.action?.buttonText ?? 'ปริ้นท์'}
          </>
        }
        variant={'outline-info'}
        id={`dropdown-variants-info`}
        key="info"
        className="text-capitalize"
      >
        {(showPrintButton?.action?.printList || []).map((print, index) => {
          if (print?.printButton) {
            return (
              <Dropdown.Item
                key={`print-${index + 1}`}
                eventKey={`print-${index + 1}`}
                onClick={() =>
                  printData(
                    print,
                    {
                      dataSelected: rowSelection,
                      datasourceValue,
                      formData,
                      designerData,
                    },
                    true,
                  )
                }
              >
                {print.printName}
              </Dropdown.Item>
            )
          }
        })}
      </DropdownButton>
    </ButtonToolbar>
  )
}

export default PrintButton
